/**
 * Created by vladislav on 06.12.2021
 */

const TextWithIcon = cleverapps.Layout.extend({
    ctor: function (text, options) {
        this._super([], this.prepareLayoutOptions(options));

        this.textOptions = options || {};
        if (this.textOptions.width || this.textOptions.height) {
            this.fitToSize = {
                width: this.textOptions.width,
                height: this.textOptions.height
            };
        }
        this.customIcons = this.textOptions.icons || {};
        this.font = this.textOptions.font || cleverapps.styles.FONTS.BUTTON_TEXT;
        this.fontSize = this.font.size;
        this.originalFontSize = this.fontSize;

        this.setString(text);
    },

    prepareLayoutOptions: function (options) {
        return {
            direction: options && options.direction || cleverapps.UI.HORIZONTAL,
            margin: options && options.margin || cleverapps.styles.TextWithIcon.margin,
            align: options && options.align
        };
    },

    setOptions: function (options) {
        this.textOptions = options || {};
        this._super(this.prepareLayoutOptions(options));

        this.updateLayout();
    },

    getItems: function () {
        return this.items;
    },
    
    calcCurrentSize: function () {
        const styles = cleverapps.styles.TextWithIcon;

        return this.items.reduce((size, part, index) => {
            size.width += part.width * part.scale;
            if (index > 0) {
                size.width += styles.margin;
            }
            size.height = Math.max(size.height, part.height * part.scale);

            return size;
        }, cc.size(0, 0));
    },

    setFontSize: function (fontSize) {
        this.fontSize = fontSize;

        this._updateFontSize();
    },

    _updateFontSize: function () {
        this.items.forEach(function (item) {
            if (item.isIcon) {
                item.setScale(this.getIconScale(item));
            } else if (item.isSpace) {
                item.width = this.getSpaceWidth();
            } else {
                item.setFontSize(this.fontSize);
            }

            item.setPosition(0, 0);
        }, this);

        this.reshape();
    },

    getFontSize: function () {
        return this.fontSize;
    },

    fitTo: function (maxWidth, maxHeight) {
        this.fitToSize = {
            width: maxWidth,
            height: maxHeight
        };

        this.setFontSize(this.originalFontSize);
        
        for (let i = 0; i < 10; i++) {
            const size = this.calcCurrentSize();
            const offLimits = maxWidth && size.width > maxWidth || maxHeight && size.height > maxHeight;
            if (!offLimits) {
                break;
            }

            let scaleX = 1;
            let scaleY = 1;
            if (maxWidth && size.width > maxWidth) {
                scaleX = maxWidth / size.width;
            }

            if (maxHeight && size.height > maxHeight) {
                scaleY = maxHeight / size.height;
            }

            let scale = 0.9;
            const minScale = Math.min(scaleX, scaleY);
            if (minScale > 0.9 && minScale < 1) {
                scale = minScale;
            }

            let fontSize = Math.floor(this.getFontSize() * scale);
            let minimumHit = false;
            if (fontSize < cleverapps.UI.ImageFont.getFontSizeThreshold()) {
                minimumHit = true;
                fontSize = cleverapps.UI.ImageFont.getFontSizeThreshold();
            }

            this.setFontSize(fontSize);
            if (minimumHit) {
                break;
            }
        }
    },

    isIcon: function (part) {
        return Boolean(TextWithIcon.ICONS[part] || Product.CURRENCY_ICONS[part] || this.customIcons[part]);
    },

    createItems: function (parts) {
        return parts.map(function (part) {
            if (this.isIcon(part)) {
                return this.createIcon(part);
            }
            if (part === " ") {
                return this.createSpace();
            }
            return this.createText(part);
        }, this);
    },

    getIconScale: function (icon) {
        if (this.textOptions.iconScale) {
            return this.textOptions.iconScale;
        }

        const minHeight = this.fontSize * (this.textOptions.iconMinHeight || 1);
        const maxHeight = this.fontSize * (this.textOptions.iconMaxHeight || 1);

        if (icon.height && icon.height < minHeight) {
            return minHeight / icon.height;
        }

        if (icon.height && icon.height > maxHeight) {
            return maxHeight / icon.height;
        }

        return 1;
    },

    getSpaceWidth: function () {
        return this.fontSize * 0.2;
    },

    createIcon: function (key) {
        let icon = this.chooseImage(key);
        if (!(icon instanceof cc.Node)) {
            icon = new cc.Sprite(icon);
        }

        icon.setScale(this.getIconScale(icon));
        icon.isIcon = true;

        return icon;
    },

    createSpace: function () {
        const space = new cc.Node();
        space.setAnchorPoint(0.5, 0.5);
        space.setContentSize(this.getSpaceWidth(), 1);
        space.isSpace = true;
        return space;
    },

    createText: function (string) {
        let text;
        if (this.textOptions.imageText !== false && cleverapps.UI.ImageFont.IsApplicable(this.font, string)) {
            text = cleverapps.UI.generateImageText(string, this.font);
        } else {
            text = cleverapps.UI.generateOnlyText(string, this.font);
        }

        text.setFontSize(this.fontSize);

        return text;
    },

    parseText: function (string) {
        const keys = [].concat(
            Object.keys(TextWithIcon.ICONS),
            Object.keys(Product.CURRENCY_ICONS),
            Object.keys(this.customIcons)
        );

        return TextWithIcon.splitString(`${string}`, keys);
    },

    chooseImage: function (key) {
        let selected = this.customIcons[key];
        if (selected) {
            return selected;
        }

        selected = Product.CURRENCY_ICONS[key];
        if (selected) {
            return selected.url;
        }

        const options = TextWithIcon.ICONS[key]
            .filter((imageOption) => cleverapps.bundleLoader.isLoaded(imageOption.bundle) && TextWithIcon.findImage(imageOption))
            .sort((imageOptionA, imageOptionB) => {
                const scaleA = Math.abs(1 - this.fontSize / imageOptionA.size);
                const scaleB = Math.abs(1 - this.fontSize / imageOptionB.size);

                return scaleA - scaleB;
            });

        selected = options[0];
        return TextWithIcon.findImage(selected);
    },

    setString: function (text) {
        this.originalString = text;

        this.updateLayout();
    },

    getString: function () {
        return this.originalString;
    },

    setFont: function (font) {
        this.font = font;
        this.fontSize = font.size;

        this.updateLayout();
    },

    updateLayout: function () {
        const parts = this.parseText(this.originalString);
        this.items = this.createItems(parts);

        if (this.fitToSize) {
            this.fitTo(this.fitToSize.width, this.fitToSize.height);
        }

        this.removeAllChildren();
        this.items.forEach(function (item) {
            this.addChild(item);
        }, this);
        this.reshape();
    },

    enable: function () {
        this.items.forEach((item) => {
            cleverapps.UI.convertToGrayScale(item, true);
        });
    },

    disable: function () {
        this.items.forEach((item) => {
            cleverapps.UI.convertToGrayScale(item);
        });
    }
});

TextWithIcon.IsApplicable = function (text, customIcons) {
    if (customIcons) {
        return true;
    }

    let key;

    text += "";

    for (key in TextWithIcon.ICONS) {
        if (text.indexOf(key) !== -1) {
            return true;
        }
    }

    for (key in Product.CURRENCY_ICONS) {
        if (text.indexOf(key) !== -1) {
            return true;
        }
    }

    return false;
};

TextWithIcon.findImage = function (imageOption) {
    return cleverapps.skins.getSlot(imageOption.name) || bundles[imageOption.bundle].frames[imageOption.name];
};

TextWithIcon.splitString = function (string, keys) {
    string = string.trim();
    string = string.replace(/ +/, " ");

    const parts = [];

    let lastIndex = 0;

    while (true) {
        let minIndex = string.length, minKey = undefined;

        for (let i = 0; i < keys.length && minIndex !== lastIndex; ++i) {
            const key = keys[i];
            const index = string.indexOf(key, lastIndex);
            if (index >= 0 && index < minIndex) {
                minIndex = index;
                minKey = key;
            }
        }

        parts.push(string.slice(lastIndex, minIndex));

        if (!minKey) {
            break;
        }

        parts.push(minKey);
        lastIndex = minIndex + minKey.length;
    }

    const result = [];

    for (let current = 0; current < parts.length; ++current) {
        const part = parts[current];

        if (part.length === 0) {
            continue;
        }

        if (part.length === 1) {
            result.push(part);
            continue;
        }

        if (part[0] === " ") {
            result.push(" ");
        }

        result.push(part.trim());

        if (part[part.length - 1] === " ") {
            result.push(" ");
        }
    }

    return result;
};

TextWithIcon.ICONS_BY_NAME = {
    rubies: "$$",
    hard: "$$",
    gold: "$$",
    energy: "%%",
    coins: "@@",
    soft: "@@",
    wands: "++",
    speedup: ">>",
    ads: "##"
};

TextWithIcon.ICONS = {
    "$$": [
        {
            name: "gold_icon_png",
            bundle: "buttons_inlined_icons",
            size: 50
        },
        {
            name: "big_gold_icon_png",
            bundle: "big_buttons",
            size: 90
        }
    ],
    "@@": [
        {
            name: "coin_icon_png",
            bundle: "buttons_inlined_icons",
            size: 50
        },
        {
            name: "big_coin_icon_png",
            bundle: "big_buttons",
            size: 90
        }
    ],
    "##": [
        {
            name: "small_ad_icon_png",
            bundle: "buttons_inlined_icons",
            size: 30
        },
        {
            name: "ad_icon_png",
            bundle: "buttons_inlined_icons",
            size: 50
        },
        {
            name: "big_ad_icon_png",
            bundle: "big_buttons",
            size: 90
        }
    ],
    "%%": [
        {
            name: "energy_icon_png",
            bundle: "buttons_inlined_icons",
            size: 50
        }
    ],
    "^^": [
        {
            name: "instant_worker_icon_png",
            bundle: "buttons_inlined_icons",
            size: 50
        }
    ],
    "++": [
        {
            name: "wand_icon_png",
            bundle: "buttons_inlined_icons",
            size: 50
        }
    ],
    "--": [
        {
            name: "worker_icon_png",
            bundle: "buttons_inlined_icons",
            size: 50
        }
    ],
    ">>": [
        {
            name: "speedup_icon_png",
            bundle: "buttons_inlined_icons",
            size: 50
        }
    ],
    "<<": [
        {
            name: "feed_icon_png",
            bundle: "buttons_inlined_icons",
            size: 50
        }
    ]
};

cleverapps.styles.TextWithIcon = {
    margin: 0
};
